export const LoreSuperType = 'Lore';
export var LoreType;
(function (LoreType) {
    LoreType[LoreType["SpellLore"] = 1] = "SpellLore";
    LoreType[LoreType["PrayerLore"] = 4] = "PrayerLore";
    LoreType[LoreType["ManifestationLore"] = 2] = "ManifestationLore";
    LoreType[LoreType["Unknown"] = 99] = "Unknown";
})(LoreType || (LoreType = {}));
export const loreTypeToString = (type) => {
    switch (type) {
        case LoreType.SpellLore:
            return 'Spell Lore';
        case LoreType.PrayerLore:
            return 'Prayer Lore';
        case LoreType.ManifestationLore:
            return 'Manifestation Lore';
        default:
            return 'Unknown';
    }
};
